




















import Vue from 'vue';
import LearningTools from '@/tools/learning';
import BbTools from '@/tools/bluebird';
import Activity from '@/components/activity/Activity.vue';

export default Vue.extend({
  components: {
    activity: Activity,
  },
  props: ['drillPhrase', 'activityIndex', 'activityDataLength'],
  data() {
    return {
      navigationVisible: false,
      drillCompleted: false,
    };
  },
  mounted() {
    this.drillCompleted = false;
    this.navigationVisible = false;
  },
  methods: {
    activityReady() {
      (this.$refs.activity as any).startPlaying();
    },
    async onNext() {
      this.navigationVisible = false;
      await BbTools.sleepCancelable(LearningTools.TO_HIDE_ACTIVITY, this.$store);
      this.$emit('next');
    },
    onActivityStopped() {
      this.navigationVisible = false;
    },
  },
  beforeDestroy() {
    if (this.$store.state.sleepPromise) {
      this.$store.state.sleepPromise.cancel();
    }
  },
});
